module.exports = __webpack_public_path__ + "img/36b2d62.jpg";